/**
 * Maps a Hospital dashboard card to a lightweight placeholder skeleton "kind"
 * used only in layout mode (`LayoutPlaceholderCard`). Keeps DOM tiny so drag
 * stays smooth — no real charts or data.
 *
 * @param {object} card  Grid card `{ component, type, … }`
 * @returns {'chart'|'table'|'kpi'|'list'|'category'|'default'}
 */
export function getHospitalLayoutSkeletonVariant(card) {
	if (!card) return 'default';

	if (card.type === 'category') {
		return 'category';
	}

	const c = card.component;
	if (!c || typeof c !== 'string') {
		return 'default';
	}

	// Analytics / time-series style cards
	const chart = new Set([
		'hospitalizations',
		'dcer',
		'insurance',
		'returns',
		'ninetyDays',
		'sixtyDays',
		'days',
		'dynamic',
	]);
	// Tabular / staff-style cards
	const table = new Set(['dx', 'doctor', 'nurse', 'shift']);
	// Big total / summary card
	const kpi = new Set(['hospital', 'safeDischargeAssLiv', 'snfFacility', 'averageStayDays', 'exhaustInsuranceData']);
	// List / breakdown rows (e.g. floors)
	const list = new Set(['floors']);

	if (chart.has(c)) return 'chart';
	if (table.has(c)) return 'table';
	if (kpi.has(c)) return 'kpi';
	if (list.has(c)) return 'list';

	return 'default';
}

export default getHospitalLayoutSkeletonVariant;
